function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Price } from '@components/frontStore/catalog/product/list/item/Price';
import { useAppDispatch, useAppState } from '@components/common/context/app';
import produce from 'immer';
import ProductCard from '@default-theme/cms/frontStore/homepage/components/productCard/ProductCard';
import ProductCardMobile from '@default-theme/cms/frontStore/homepage/components/productCard/ProductCardMobile';
import '../../../../../modules/catalog/pages/frontStore/productView/Form.scss';
import { extractDescriptionText } from '@default-theme/cms/frontStore/homepage/utils/categoryHelpers';
import { useLanguage } from '@components/common/locale/useLanguage';
import { _ } from '@evershop/evershop/src/lib/locale/translate';
export function PriceAndAddToCart(_ref) {
  var {
    price,
    stockAvaibility,
    productId,
    qty,
    url,
    name
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mt-4 px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-container"
  }, /*#__PURE__*/React.createElement(Price, _extends({}, price, {
    name: name
  }))), /*#__PURE__*/React.createElement(AddToCart, {
    stockAvaibility: stockAvaibility,
    productId: productId,
    qty: qty,
    url: url,
    name: name
  }));
}
PriceAndAddToCart.propTypes = {
  price: PropTypes.shape({
    regular: PropTypes.shape({
      value: PropTypes.number,
      text: PropTypes.string
    }),
    special: PropTypes.shape({
      value: PropTypes.number,
      text: PropTypes.string
    })
  }).isRequired,
  stockAvaibility: PropTypes.bool.isRequired,
  productId: PropTypes.number.isRequired,
  qty: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};
function AddToCart(_ref2) {
  var {
    stockAvaibility,
    loading = false,
    qty = 1,
    url,
    name,
    productId
  } = _ref2;
  var appContext = useAppState();
  var {
    setData
  } = useAppDispatch();
  var [, setError] = useState();
  var handleAddToCart = async () => {
    try {
      var response = await fetch('/api/cart/mine/items', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          product_id: productId,
          qty,
          name,
          product_note: '',
          product_price: ''
        })
      });
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
      var result = await response.json();
      if (!result.error) {
        setData(produce(appContext, draft => {
          draft.cart = appContext.cart || {};
          draft.cart.totalQty = result.data.count;
          draft.cart.uuid = result.data.cartId;
        }));
      } else {
        setError(result.error.message);
      }
    } catch (error) {
      throw new Error('Error adding to cart:', error);
    }
  };
  return /*#__PURE__*/React.createElement("div", null, stockAvaibility !== false && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "bg-bremerGold rounded-full px-2 py-2",
    onClick: () => {
      window.location.href = url;
    }
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 9",
    d: "M12.5713 5.40576L12.5713 19.7391",
    stroke: "#2A2A2A",
    strokeWidth: "2.00667",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 10",
    d: "M19.7383 12.5737L5.40495 12.5737",
    stroke: "#2A2A2A",
    strokeWidth: "2.00667",
    strokeLinecap: "round"
  })))));
}
AddToCart.propTypes = {
  loading: PropTypes.bool,
  stockAvaibility: PropTypes.bool.isRequired,
  productId: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  qty: PropTypes.number,
  name: PropTypes.string.isRequired
};
AddToCart.defaultProps = {
  loading: false,
  qty: 1
};
export default function ProductList(_ref3) {
  var _appContext$setting;
  var {
    products = [],
    countPerRow = 3
  } = _ref3;
  var {
    isAr
  } = useLanguage();
  if (products.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: " flex flex-col items-center justify-center gap-[3.3rem]"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mt-[4.2rem]"
    }, /*#__PURE__*/React.createElement("svg", {
      className: "w-[19.16rem]",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 307 431",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M121.365 168.216C121.165 168.216 120.971 168.154 120.808 168.038C120.6 167.89 120.458 167.665 120.415 167.413C120.372 167.16 120.431 166.901 120.579 166.693C120.757 166.441 138.196 141.23 118.728 118.246C115.282 114.157 110.984 110.87 106.135 108.618C101.285 106.365 96.0014 105.2 90.6541 105.204H90.3916C92.2404 111.626 91.9104 117.337 89.2926 121.717C88.1772 123.697 86.5312 125.326 84.54 126.42C82.5488 127.515 80.2915 128.031 78.0225 127.912C76.1443 127.758 74.3517 127.06 72.8642 125.903C71.3768 124.746 70.2591 123.18 69.6481 121.397C67.507 115.812 69.7446 110.397 75.6421 106.907C79.3782 104.847 83.5296 103.653 87.7893 103.413C86.4035 99.7391 84.6016 96.2359 82.4186 92.9719C75.3893 82.2364 62.5783 74.8047 47.2691 72.5825C34.295 70.7 21.8612 72.9174 15.5884 78.2301C15.393 78.3954 15.1399 78.4764 14.8849 78.4551C14.6298 78.4338 14.3936 78.3121 14.2283 78.1167C14.063 77.9214 13.9821 77.6683 14.0033 77.4132C14.0246 77.1582 14.1463 76.922 14.3417 76.7567C21.0169 71.1033 34.0499 68.7133 47.546 70.6778C63.4023 72.9801 76.7006 80.7215 84.0339 91.9192C86.4113 95.4705 88.3452 99.2994 89.7924 103.321C95.5608 103.182 101.287 104.339 106.549 106.707C111.81 109.075 116.474 112.593 120.196 117.003C140.645 141.144 122.335 167.549 122.148 167.814C122.058 167.938 121.941 168.039 121.805 168.109C121.669 168.179 121.518 168.216 121.365 168.216ZM88.4155 105.274C84.2855 105.451 80.252 106.578 76.6292 108.569C71.5384 111.581 69.6529 116.006 71.4544 120.707C71.9425 122.148 72.8399 123.415 74.0368 124.353C75.2336 125.291 76.678 125.861 78.1933 125.991C80.1012 126.076 81.9953 125.629 83.6637 124.7C85.3321 123.771 86.7091 122.396 87.6407 120.728C90.0433 116.705 90.2633 111.356 88.4126 105.274H88.4155Z",
      fill: "#CF221E"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M176.182 128.106C175.975 128.106 175.774 128.039 175.608 127.916C175.442 127.794 175.32 127.621 175.259 127.423C172.059 115.472 171.205 103.013 172.745 90.7367C175.239 72.7895 185.137 49.2352 218.124 38.9213C222.765 37.429 227.526 36.3376 232.354 35.659C233.909 25.9511 239.822 15.4201 253.046 8.15439C284.465 -9.10969 305.688 6.37993 305.899 6.53817C306.103 6.69172 306.239 6.9203 306.275 7.17364C306.311 7.42698 306.245 7.68431 306.092 7.88904C305.938 8.09377 305.709 8.22911 305.456 8.26531C305.203 8.3015 304.945 8.23557 304.741 8.08202C304.54 7.9315 284.258 -6.79392 253.976 9.84683C241.619 16.6369 235.963 26.3824 234.355 35.4294C248.904 33.9965 255.872 38.8499 258.999 42.5156C260.934 44.72 262.178 47.4449 262.575 50.351C262.972 53.257 262.505 56.2156 261.232 58.8582C260.226 60.9941 258.597 62.7748 256.558 63.965C254.519 65.1553 252.167 65.6991 249.812 65.5247C241.687 65.0481 234.963 58.2127 232.683 48.1101C231.932 44.6903 231.732 41.1722 232.091 37.6892C227.55 38.3416 223.071 39.3715 218.701 40.7682C192.991 48.8068 178.175 65.711 174.655 91.0079C173.147 103.006 173.979 115.182 177.104 126.864C177.148 127.008 177.158 127.161 177.132 127.309C177.107 127.458 177.047 127.599 176.957 127.72C176.868 127.841 176.751 127.94 176.616 128.008C176.481 128.076 176.332 128.111 176.182 128.111V128.106ZM234.058 37.4479C233.656 40.8646 233.828 44.3245 234.566 47.6846C236.651 56.9265 242.68 63.1723 249.925 63.5978C251.9 63.7393 253.872 63.2806 255.581 62.2819C257.291 61.2832 258.658 59.7911 259.505 58.0014C260.608 55.697 261.009 53.119 260.658 50.5884C260.306 48.0579 259.218 45.6866 257.529 43.77C253.017 38.4756 244.783 36.3373 234.058 37.4479V37.4479Z",
      fill: "#CF221E"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M19.6376 198.075H10.2878C6.26288 198.075 3.00005 194.813 3.00003 190.788C3.00002 186.763 6.26285 183.5 10.2878 183.5H295.187C299.212 183.5 302.475 186.763 302.475 190.788C302.475 194.813 299.212 198.075 295.187 198.075H285.838M19.6376 198.075L49.7941 404.532C51.5849 416.792 62.0987 425.881 74.4884 425.881H230.987C243.376 425.881 253.89 416.792 255.681 404.532L285.838 198.075M19.6376 198.075H285.838",
      stroke: "black",
      strokeWidth: "6"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "41.5",
      y1: "200",
      x2: "41.5",
      y2: "341",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "56.5",
      y1: "200",
      x2: "56.5",
      y2: "419",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "71.5",
      y1: "200",
      x2: "71.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "86.5",
      y1: "200",
      x2: "86.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "101.5",
      y1: "200",
      x2: "101.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "116.5",
      y1: "200",
      x2: "116.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "131.5",
      y1: "200",
      x2: "131.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "146.5",
      y1: "200",
      x2: "146.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "161.5",
      y1: "200",
      x2: "161.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "176.5",
      y1: "200",
      x2: "176.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "191.5",
      y1: "200",
      x2: "191.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "206.5",
      y1: "200",
      x2: "206.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "221.5",
      y1: "200",
      x2: "221.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "236.5",
      y1: "200",
      x2: "236.5",
      y2: "425",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "251.5",
      y1: "200",
      x2: "251.5",
      y2: "414",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("line", {
      x1: "266.5",
      y1: "200",
      x2: "266.5",
      y2: "331",
      stroke: "black",
      strokeWidth: "3"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M49.7812 357.528C48.8788 353.714 51.816 350.073 55.7348 350.148L260 354.056L253.208 401.275C253.071 402.226 252.708 403.13 252.15 403.911L240.295 420.49C239.168 422.065 237.351 423 235.414 423H70.0181C67.2365 423 64.8197 421.088 64.1793 418.381L49.7812 357.528Z",
      fill: "#F9F9F9"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M236.115 385.863C236.115 385.986 236.131 386.112 236.163 386.233C236.189 386.358 236.232 386.482 236.296 386.605C236.349 386.729 236.408 386.84 236.471 386.939C236.525 387.038 236.589 387.15 236.647 387.274C236.706 387.397 236.791 387.509 236.908 387.608C237.025 387.706 237.141 387.805 237.264 387.904C237.376 388.024 237.493 388.101 237.615 388.2C237.732 388.301 237.876 388.41 238.138 388.534C238.232 388.66 238.408 388.77 238.583 388.868L247.93 394.956C248.633 395.4 249.25 395.835 249.782 396.254C250.308 396.676 250.734 397.12 251.053 397.591C251.377 398.06 251.612 398.583 251.76 399.038C251.904 399.534 251.979 400.076 251.979 400.671V413.512C251.979 414.255 251.988 414.948 251.846 415.591C251.76 416.235 251.627 416.841 251.452 417.408C251.277 417.978 251.053 418.593 250.792 418.967C250.527 419.438 250.218 419.885 249.867 420.331C249.516 420.726 249.117 421.109 248.68 421.455C247.625 422.29 246.293 422.756 245.005 423.128C243.618 423.533 242.144 423.759 240.683 423.851C238.388 423.997 236.055 423.845 233.785 423.496C232.992 423.472 232.294 423.2 231.582 422.975C230.907 422.753 230.279 422.506 229.694 422.278C229.104 421.961 228.577 421.641 228.109 421.268C227.729 420.899 227.226 420.49 226.875 420.044C226.523 419.599 226.199 419.128 225.906 418.633C225.614 418.139 225.38 417.594 225.293 417C225.029 416.408 224.896 415.764 224.805 415.071C224.72 414.378 224.673 413.66 224.673 412.918C224.673 412.72 224.673 412.519 224.673 412.213C224.673 411.942 224.673 411.632 224.673 411.285C224.673 410.94 224.688 410.569 224.72 410.172C224.747 409.775 224.763 409.381 224.763 408.984C224.763 408.589 224.779 408.167 224.805 407.742C224.838 407.362 224.864 406.844 224.896 406.424C224.923 406.003 224.938 405.594 224.938 405.2C224.938 404.802 224.954 404.433 224.981 404.085C225.013 403.74 225.04 403.441 225.071 403.12C225.098 402.824 225.114 402.575 225.114 402.378L235.679 401.635V413.14C235.679 413.882 235.923 414.44 236.444 414.811C236.923 415.183 237.641 415.367 238.583 415.367C240.754 415.367 240.978 414.625 240.978 413.14V402.082C240.978 401.389 240.786 400.77 240.403 400.225C240.025 399.756 239.424 399.161 238.6 398.666L229.955 393.024C229.662 392.903 229.396 392.717 229.162 392.621C228.928 392.37 228.694 392.183 228.46 391.986C228.226 391.788 228.002 391.591 227.8 391.391C227.593 391.194 227.476 390.983 227.226 390.761C227.087 390.539 226.891 390.315 226.742 390.093C226.598 389.871 226.465 389.649 226.348 389.424C226.231 389.202 226.114 388.981 225.997 388.759C225.875 388.534 225.79 388.301 225.731 388.052C225.673 387.805 225.63 387.57 225.598 387.348C225.566 387.123 225.556 386.89 225.556 386.731V372.613C225.556 369.942 226.348 367.925 227.933 366.564C229.514 365.202 231.865 364.523 234.971 364.523C235.576 364.523 236.014 364.624 236.514 364.597C237.086 364.646 237.495 364.707 237.876 364.783C238.285 364.857 238.684 364.956 239.068 365.079C239.445 365.202 239.856 365.35 240.078 365.523C240.371 365.698 240.636 365.895 240.871 366.118C241.105 366.342 241.323 366.6 241.53 366.898C241.738 367.194 241.897 367.517 242.015 367.862C242.132 368.211 242.248 368.58 242.365 368.975C242.483 369.372 242.572 369.792 242.589 370.238C242.615 370.682 242.632 371.178 242.632 371.723H243.509L244.477 365.265H251.962V386.18L241.839 386.922V375.285C241.839 374.592 241.605 374.049 241.136 373.652C240.663 373.257 239.961 373.057 239.02 373.057C237.083 373.057 236.115 373.8 236.115 375.285V385.455C236.115 385.603 236.115 385.793 236.115 385.863ZM214.021 392.367C215.484 392.367 216.686 392.691 217.627 393.339C218.564 393.989 219.154 394.961 219.389 396.257L223.563 423.162H212.386L209.08 396.583H204.69L204.641 423.162H193.634V365.259H207.753C208.716 365.259 209.657 365.299 210.535 365.38C211.418 365.46 212.293 365.571 213.003 365.705C213.764 365.84 214.482 366.029 215.158 366.271C215.833 366.516 216.445 366.786 217.004 367.082C217.623 367.454 218.062 367.731 218.504 368.135C218.94 368.542 219.339 368.988 219.69 369.473C220.041 369.96 220.35 370.487 220.616 371.055C220.876 371.621 221.1 372.243 221.276 372.92C221.451 373.595 221.584 374.311 221.669 375.068C221.759 375.824 221.802 376.636 221.802 377.5L221.851 378.911C221.851 379.83 221.82 380.683 221.766 381.464C221.703 382.248 221.601 382.978 221.458 383.654C221.309 384.33 221.118 385.041 220.883 385.518C220.649 386.182 220.383 386.611 220.091 387.141C219.798 387.586 219.447 388.017 219.037 388.394C218.623 388.773 218.171 389.111 217.671 389.408C217.17 389.77 216.627 389.964 216.042 390.18C215.457 390.395 214.798 390.571 214.063 390.706C213.33 390.912 212.553 390.936 211.728 390.988C210.909 391.044 210.026 391.17 209.09 391.17V392.367H214.021ZM210.015 386.936C210.568 386.449 210.923 385.775 210.923 384.911L210.801 377.067C210.801 376.851 210.785 376.689 210.759 376.528C210.726 376.364 210.695 376.202 210.668 376.04C210.636 375.926 210.593 375.729 210.535 375.595C210.476 375.459 210.402 375.34 210.317 375.229C210.226 375.121 210.125 375.014 210.008 374.906C209.891 374.798 209.774 374.717 209.657 374.661C209.54 374.609 209.407 374.541 209.258 374.46C209.188 374.379 208.966 374.325 208.822 374.299C208.673 374.271 208.514 374.245 208.338 374.215C208.157 374.191 207.981 374.207 207.806 374.207H204.641L204.69 387.725H207.771C208.706 387.725 209.484 387.421 210.015 386.936ZM166.877 365.259H190.118V374.207H177.883V387.648H187.475V396.564H177.883V414.246H190.996V423.162H166.877V365.259ZM152.881 391.542C154.349 391.542 155.535 391.866 156.525 392.515C157.355 393.161 158.016 394.136 158.248 395.432L164.674 423.162H153.232L149.71 403.783C149.567 403.567 149.524 403.349 149.492 403.133C149.46 402.918 149.434 402.7 149.407 402.485C149.375 402.269 149.343 402.039 149.317 401.796C149.284 401.551 149.258 401.308 149.226 401.066C149.2 400.824 149.184 400.579 149.184 400.336C149.184 400.094 149.167 399.836 149.141 399.627C149.109 399.298 149.099 399.041 149.099 398.795C149.099 398.553 149.082 398.31 149.051 398.066C149.024 397.823 149.008 397.58 149.008 397.338C149.008 397.093 149.008 396.838 149.008 396.566H146.194V423.162H135.187V365.259H146.194V387.65H148.939C148.939 387.445 148.939 387.219 148.939 387.001C148.939 386.785 148.934 386.555 148.965 386.312C148.992 386.07 149.008 385.813 149.008 385.543C149.008 385.274 149.024 385.016 149.051 384.772C149.082 384.529 149.109 384.275 149.141 384.003C149.167 383.733 149.2 383.464 149.226 383.192C149.258 382.922 149.284 382.653 149.317 382.381C149.343 382.153 149.457 381.842 149.45 381.57C149.582 381.3 149.551 381.043 149.582 380.801C149.609 380.556 149.652 380.328 149.71 380.11L153.588 365.259H163.797L157.195 390.244H150.152V391.542H152.881ZM131.145 416.394C130.969 417.07 130.746 417.69 130.485 418.258C130.219 418.827 129.911 419.339 129.559 419.799C129.208 420.257 128.809 420.691 128.368 421.14C127.931 421.502 127.431 421.852 126.873 422.148C126.314 422.447 125.713 422.717 125.069 422.959C124.421 423.204 123.734 423.393 123.047 423.527C122.266 423.662 121.463 423.77 120.58 423.851C119.702 423.966 118.793 423.973 117.851 423.973C116.851 423.973 115.931 423.966 115.079 423.851C114.228 423.77 113.419 423.662 112.659 423.527C111.976 423.393 111.204 423.204 110.547 422.959C109.898 422.717 109.297 422.447 108.744 422.148C108.23 421.852 107.685 421.502 107.244 421.14C106.807 420.691 106.408 420.257 106.057 419.799C105.706 419.339 105.398 418.827 105.132 418.258C104.871 417.69 104.648 417.07 104.472 416.394C104.296 415.718 104.163 415.003 104.078 414.246C103.988 413.489 103.945 412.678 103.945 411.813V376.283C103.945 375.528 103.988 374.798 104.078 374.095C104.163 373.392 104.28 372.731 104.43 372.109C104.573 371.489 104.749 370.906 104.956 370.367C105.163 369.826 105.459 369.311 105.706 368.826C105.998 368.339 106.323 367.893 106.674 367.514C107.049 367.082 107.419 366.717 107.86 366.393C108.359 366.07 108.872 365.82 109.27 365.541C109.77 365.299 110.297 365.095 110.855 364.934C111.409 364.83 111.999 364.649 112.616 364.569C113.228 364.488 113.893 364.449 114.595 364.449C115.122 364.449 115.606 364.476 116.048 364.53C116.489 364.583 116.915 364.649 117.358 364.733C117.734 364.814 118.117 364.934 118.468 365.095C118.819 365.259 119.143 365.47 119.436 365.664C119.729 365.882 120.077 366.11 120.331 366.352C120.463 366.597 120.67 366.881 120.846 367.205C121.022 367.528 121.181 367.893 121.33 368.299C121.474 368.704 121.59 369.123 121.681 369.556C121.766 370.056 121.825 370.46 121.857 370.974C121.883 371.489 121.899 372.043 121.899 372.635H122.867L123.836 365.259H131.23V387.648L121.107 388.51V376.364C121.107 375.501 120.846 374.852 120.314 374.418C119.787 373.987 119.085 373.77 118.202 373.77C118.105 373.77 117.835 373.784 117.633 373.811C117.425 373.887 117.234 373.865 117.058 373.892C116.883 373.919 116.723 373.973 116.574 374.054C116.431 374.134 116.298 374.203 116.181 374.257C116.063 374.311 115.946 374.392 115.922 374.499C115.744 374.609 115.606 374.717 115.521 374.825C115.431 374.933 115.345 375.055 115.255 375.19C115.17 375.325 115.106 375.472 115.079 375.636C115.048 375.798 115.021 375.959 114.989 376.121C114.963 376.283 114.946 376.489 114.946 376.608V411.894C114.946 412.759 115.223 413.435 115.781 413.92C116.34 414.408 117.09 414.65 118.105 414.65C118.968 414.65 119.713 414.408 120.272 413.92C120.83 413.435 121.107 412.759 121.107 411.894V397.375L130.788 396.564C130.847 396.998 130.905 397.429 130.969 397.885C131.022 398.296 131.07 398.754 131.108 399.239C131.235 401.752 131.414 404.262 131.533 406.775C131.65 409.243 131.832 411.786 131.538 414.246C131.535 415.003 131.32 415.718 131.145 416.394ZM89.0527 365.259H99.9825V423.162H89.0527V365.259ZM74.5195 391.615C75.9876 391.615 77.1741 391.837 78.0837 392.487C78.9934 393.133 79.614 394.108 79.8868 395.405L86.3848 423.162H74.8703L71.3096 403.766C71.2054 403.54 71.1629 403.321 71.1308 403.106C71.0992 402.89 71.0725 402.672 71.0458 402.456C71.0136 402.241 70.982 402.011 70.9554 401.768C70.9232 401.523 70.8965 401.281 70.8649 401.082C70.8383 400.796 70.8224 400.551 70.8224 400.308C70.8224 400.066 70.8998 399.809 70.7799 399.539C70.7479 399.27 70.7369 399.012 70.7369 398.824C70.7369 398.525 70.7211 398.283 70.776 398.037C70.6628 397.795 70.6465 397.552 70.6465 397.31C70.6465 397.065 70.6465 396.811 70.6465 396.539H65.0336V423.162L57.477 420.688C55.852 420.156 54.7448 418.65 54.7218 416.941L54.0273 365.259H65.0336V387.622H70.5615C70.5615 387.406 70.5615 387.191 70.5615 386.973C70.5615 386.795 70.6464 386.561 70.604 386.285C70.6308 386.042 70.6465 385.785 70.6465 385.593C70.6465 385.246 70.6628 384.989 70.776 384.744C70.7211 384.501 70.7479 384.246 70.7799 383.974C70.8998 383.705 70.8383 383.436 70.8649 383.164C70.8965 382.895 70.9232 382.625 70.9554 382.353C70.982 382.083 71.0549 381.814 71.0883 381.564C71.1799 381.273 71.1895 381.016 71.2211 380.773C71.2479 380.606 71.2904 380.368 71.3487 380.082L75.2272 365.259H85.4354L78.8338 390.216H71.7905V391.615H74.5195Z",
      fill: "black"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "text-center flex items-center flex-col gap-[0.4rem] "
    }, /*#__PURE__*/React.createElement("p", {
      className: "font-medium text-[2.4rem] text-[#C60910] uppercase"
    }, _('Sorry we couldn’t find this item.')), /*#__PURE__*/React.createElement("p", {
      className: "text-[1.6rem] text-[#717171] font-rubik max-w-[33.6rem] leading-normal"
    }, _('Write it again correctly and it will appear.')), /*#__PURE__*/React.createElement("a", {
      type: "button",
      href: "/",
      className: "text-white text-[1.6rem] font-zoom-pro-normal font-[500] bg-[#000000] rounded-[8px] px-[16px] py-[8px] mt-[1.6rem] mx-auto w-fit flex gap-[8px] uppercase"
    }, _('Menu'), /*#__PURE__*/React.createElement("svg", {
      width: "27",
      height: "27",
      viewBox: "0 0 27 27",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: isAr ? 'rotate-180' : ''
    }, /*#__PURE__*/React.createElement("rect", {
      width: "26.4016",
      height: "26.4016",
      rx: "13.2008",
      fill: "white"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.9202 18.6065C13.8685 18.5547 13.8274 18.4933 13.7994 18.4257C13.7713 18.3581 13.7569 18.2856 13.7569 18.2124C13.7569 18.1393 13.7713 18.0668 13.7994 17.9992C13.8274 17.9316 13.8685 17.8702 13.9202 17.8184L17.9822 13.7572L7.07444 13.7572C6.92674 13.7572 6.78508 13.6985 6.68064 13.5941C6.5762 13.4896 6.51753 13.348 6.51753 13.2003C6.51753 13.0526 6.5762 12.9109 6.68064 12.8065C6.78508 12.702 6.92674 12.6434 7.07444 12.6434L17.9822 12.6434L13.9202 8.58209C13.8157 8.47759 13.757 8.33586 13.757 8.18808C13.757 8.04029 13.8157 7.89856 13.9202 7.79406C14.0247 7.68957 14.1665 7.63086 14.3143 7.63086C14.462 7.63086 14.6038 7.68957 14.7083 7.79406L19.7205 12.8062C19.7722 12.858 19.8133 12.9194 19.8413 12.987C19.8694 13.0546 19.8838 13.1271 19.8838 13.2003C19.8838 13.2734 19.8694 13.3459 19.8413 13.4135C19.8133 13.4811 19.7722 13.5426 19.7205 13.5943L14.7083 18.6065C14.6565 18.6582 14.5951 18.6993 14.5275 18.7273C14.4599 18.7554 14.3874 18.7698 14.3143 18.7698C14.2411 18.7698 14.1686 18.7554 14.101 18.7273C14.0334 18.6993 13.972 18.6582 13.9202 18.6065Z",
      fill: "#060708"
    })))));
  }
  var gridClassName;
  switch (countPerRow) {
    case 3:
      gridClassName = 'grid grid-cols-2 gap-x-4 gap-y-[5rem] lg:grid-cols-3 xl:grid-cols-3 md:gap-y-[6rem] mt-[4rem] max-w-[98rem] mx-auto';
      break;
    case 4:
      gridClassName = 'grid grid-cols-2 gap-x-4 gap-y-[8rem] md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-y-[6rem] mt-[8rem]';
      break;
    case 5:
      gridClassName = 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-8 md:mt-20';
      break;
    default:
      gridClassName = 'grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 md:mt-8';
  }
  var appContext = useAppState();
  var storeStatus = appContext === null || appContext === void 0 || (_appContext$setting = appContext.setting) === null || _appContext$setting === void 0 ? void 0 : _appContext$setting.storeStatus;
  return /*#__PURE__*/React.createElement("div", {
    className: gridClassName
  }, products.map(p => {
    var _p$customizationGroup, _p$image, _p$description, _p$descriptionAr, _p$categories, _p$categories2, _p$category, _p$category2, _p$categories3, _p$category3, _p$image2, _p$description2, _p$descriptionAr2, _p$categories4, _p$categories5, _p$category4, _p$category5, _p$categories6, _p$category6;
    var isCustomizable = !!((_p$customizationGroup = p.customizationGroups) !== null && _p$customizationGroup !== void 0 && _p$customizationGroup.length);
    return /*#__PURE__*/React.createElement("div", {
      key: p.productId,
      className: "w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "hidden md:block"
    }, /*#__PURE__*/React.createElement(ProductCard, {
      currency: "EGP",
      url: p === null || p === void 0 ? void 0 : p.url,
      image: p === null || p === void 0 || (_p$image = p.image) === null || _p$image === void 0 ? void 0 : _p$image.url,
      name: p.name,
      nameAr: p.nameAr,
      price: p.price.regular.value,
      productId: p.productId,
      description: extractDescriptionText((_p$description = p.description) === null || _p$description === void 0 ? void 0 : _p$description[0]),
      descriptionAr: extractDescriptionText((_p$descriptionAr = p.descriptionAr) === null || _p$descriptionAr === void 0 ? void 0 : _p$descriptionAr[0]),
      storeStatus: storeStatus,
      isSpicy: p.isSpicy,
      category: isAr ? ((_p$categories = p.categories) === null || _p$categories === void 0 || (_p$categories = _p$categories[0]) === null || _p$categories === void 0 ? void 0 : _p$categories.nameAr) || ((_p$categories2 = p.categories) === null || _p$categories2 === void 0 || (_p$categories2 = _p$categories2[0]) === null || _p$categories2 === void 0 ? void 0 : _p$categories2.name) || ((_p$category = p.category) === null || _p$category === void 0 ? void 0 : _p$category.nameAr) || ((_p$category2 = p.category) === null || _p$category2 === void 0 ? void 0 : _p$category2.name) : ((_p$categories3 = p.categories) === null || _p$categories3 === void 0 || (_p$categories3 = _p$categories3[0]) === null || _p$categories3 === void 0 ? void 0 : _p$categories3.name) || ((_p$category3 = p.category) === null || _p$category3 === void 0 ? void 0 : _p$category3.name),
      isCustomizable: isCustomizable
    })), /*#__PURE__*/React.createElement("div", {
      className: " md:hidden flex flex-col"
    }, /*#__PURE__*/React.createElement(ProductCardMobile
    // className="mb-[3rem]"
    , {
      currency: "EGP",
      url: p === null || p === void 0 ? void 0 : p.url,
      image: p === null || p === void 0 || (_p$image2 = p.image) === null || _p$image2 === void 0 ? void 0 : _p$image2.url,
      name: p.name,
      nameAr: p.nameAr,
      price: p.price.regular.value,
      productId: p.productId,
      description: extractDescriptionText((_p$description2 = p.description) === null || _p$description2 === void 0 ? void 0 : _p$description2[0]),
      descriptionAr: extractDescriptionText((_p$descriptionAr2 = p.descriptionAr) === null || _p$descriptionAr2 === void 0 ? void 0 : _p$descriptionAr2[0]),
      storeStatus: storeStatus,
      isSpicy: p.isSpicy,
      category: isAr ? ((_p$categories4 = p.categories) === null || _p$categories4 === void 0 || (_p$categories4 = _p$categories4[0]) === null || _p$categories4 === void 0 ? void 0 : _p$categories4.nameAr) || ((_p$categories5 = p.categories) === null || _p$categories5 === void 0 || (_p$categories5 = _p$categories5[0]) === null || _p$categories5 === void 0 ? void 0 : _p$categories5.name) || ((_p$category4 = p.category) === null || _p$category4 === void 0 ? void 0 : _p$category4.nameAr) || ((_p$category5 = p.category) === null || _p$category5 === void 0 ? void 0 : _p$category5.name) : ((_p$categories6 = p.categories) === null || _p$categories6 === void 0 || (_p$categories6 = _p$categories6[0]) === null || _p$categories6 === void 0 ? void 0 : _p$categories6.name) || ((_p$category6 = p.category) === null || _p$category6 === void 0 ? void 0 : _p$category6.name),
      isCustomizable: isCustomizable
    })));
  }));
}
ProductList.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    productId: PropTypes.number,
    url: PropTypes.string,
    price: PropTypes.shape({
      regular: PropTypes.shape({
        value: PropTypes.number,
        text: PropTypes.string
      }),
      special: PropTypes.shape({
        value: PropTypes.number,
        text: PropTypes.string
      })
    }),
    image: PropTypes.shape({
      alt: PropTypes.string,
      listing: PropTypes.string
    }),
    inventory: PropTypes.shape({
      isInStock: PropTypes.bool
    })
  })).isRequired,
  countPerRow: PropTypes.number.isRequired
};
export var query = "\n  query Query {\n    product(id: getContextValue('productId')) {\n      productId\n \n      name\n      gallery {\n        thumb\n      }\n      inventory {\n        isInStock\n      }\n    }\n    action:url (routeId: \"addMineCartItem\")\n  }\n";